import { gql } from '@apollo/client';

const DASHBOARD_GET_PROFILE = gql`
  query DashboardGetPerson($personId: ID!) {
    getPerson(personId: $personId) {
      id
      firstName
      middleName
      lastName
      suffix
      dob
      sex
      tobacco
      maritalStatus
      languageWritten
      languageSpoken
      locale
      email
      addresses {
        id
        streetAddress
        apartmentSuite
        city
        zipcode
        county
        countyFips
        state
        addressType
        region
      }
      relationships {
        type
        targetPerson {
          id
          dob
          sex
          tobacco
        }
      }
    }
  }
`;

export default DASHBOARD_GET_PROFILE;
